<div
  class="details"
  [ngClass]="
    sameLine
      ? 'text-center d-flex justify-content-around align-items-baseline sticky-cta mt-0 mt-lg-4'
      : 'ms-3 ms-lg-0 text-center'
  "
  [ngSwitch]="buttonState"
  *ngIf="!isGamePending"
>
  <ng-container *ngSwitchCase="'player-link'">
    <div class="question-text font-size-14 pe-1">
      <span class="text-primary fw-bold">{{ selectedPlayer.PlayerName }}</span>
    </div>
    <button
      class="btn btn-success btn-select fw-bold mb-2 rounded-4"
      [routerLink]="['/games/pickaplayer/' + game.GameId]"
      routerLinkActive="router-link-active"
    >
      {{ 'pick.player.change.player.button' | translate }}
    </button>
  </ng-container>

  <ng-container *ngSwitchCase="'no-player-link'">
    <div class="question-text text-info fw-bold font-size-14">{{ 'pick.player.no.player.selected' | translate }}</div>
    <button
      class="btn btn-primary btn-select text-white fw-bold w-100 mb-2 rounded-4"
      [routerLink]="['/games/pickaplayer/' + game.GameId]"
      routerLinkActive="router-link-active"
    >
      {{ 'pick.player.select.player.button' | translate }}
    </button>
  </ng-container>

  <ng-container *ngSwitchCase="'make-selection'">
    <div class="question-text font-size-14 pe-1">
      <span class="text-info fw-bold">{{ 'pick.player.no.player.selected' | translate }}</span>
    </div>
    <button class="btn btn-primary btn-select btn-submit text-white fw-bold mb-2 rounded-4 btn-make-selection" [disabled]="true">
      {{ 'pick.player.submit.button' | translate }}
    </button>
  </ng-container>

  <ng-container *ngSwitchCase="'changing-player'">
    <div class="question-text font-size-14 pe-1">
      <span class="text-primary fw-bold">{{ selectedPlayer.PlayerName }}</span>
    </div>
    <button class="btn btn-primary btn-select fw-bold mb-2 rounded-4" (click)="buttonClick()">
      {{ 'pick.player.change.player.button' | translate }}
    </button>
  </ng-container>

  <ng-container *ngSwitchCase="'confirm'">
    <div class="question-text font-size-14 pe-1">
      <ng-container *ngIf="selectedPlayer">
        <span class="text-primary fw-bold">{{ selectedPlayer.PlayerName }}</span>
      </ng-container>
    </div>
    <button class="btn btn-primary btn-select btn-submit text-white fw-bold mb-2 rounded-4" (click)="buttonClick()">
      {{ 'pick.player.submit.button' | translate }}
    </button>
  </ng-container>
</div>
